module.exports = __webpack_public_path__ + "img/suite.219727d1.jpg";